module.exports = __webpack_public_path__ + "media/video_compressed_muted_480p.b1665943.mp4";